export const generateInstallments = (
  totalAmountReais,
  installmentsCount,
  firstDueDate,
  method,
  type,
  clientName,
  clientId
) => {
  const count = Math.max(1, Number.parseInt(String(installmentsCount), 10) || 1);

  const totalReaisNum = parseReaisNumber(totalAmountReais);
  const totalCents = Math.round((Number.isFinite(totalReaisNum) ? totalReaisNum : 0) * 100);

  const base = Math.floor(totalCents / count);
  const remainder = totalCents - base * count;

  const first = parseDueDate(firstDueDate);

  const out = [];
  for (let i = 0; i < count; i += 1) {
    const amountDue = base + (i === count - 1 ? remainder : 0);
    const dueDate = addMonths(first, i);

    out.push({
      clientId: String(clientId || ''),
      clientName: String(clientName || ''),
      type: String(type || ''),
      amountDue,
      dueDate,
      status: 'PENDING',
      paymentIntent: { method: String(method || '') },
    });
  }

  return out;
};

const parseReaisNumber = (input) => {
  if (typeof input === 'number') return input;

  const raw = String(input || '').trim();
  if (!raw) return 0;

  const s = raw.replace(/\s+/g, '');
  const hasComma = s.includes(',');
  const hasDot = s.includes('.');

  let normalized = s;

  if (hasComma && hasDot) {
    const commaLast = s.lastIndexOf(',');
    const dotLast = s.lastIndexOf('.');

    if (commaLast > dotLast) {
      normalized = s.replace(/\./g, '').replace(',', '.');
    } else {
      normalized = s.replace(/,/g, '');
    }
  } else if (hasComma) {
    normalized = s.replace(/\./g, '').replace(',', '.');
  } else if (hasDot) {
    if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
      normalized = s.replace(/\./g, '');
    }
  }

  const num = Number(normalized);
  return Number.isFinite(num) ? num : 0;
};

const parseDueDate = (input) => {
  if (!input) return new Date();

  if (input instanceof Date && Number.isFinite(input.getTime())) {
    return new Date(input.getTime());
  }

  const s = String(input).trim();
  if (!s) return new Date();

  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const d = new Date(`${s}T00:00:00`);
    if (Number.isFinite(d.getTime())) return d;
  }

  const d = new Date(s);
  if (Number.isFinite(d.getTime())) return d;

  return new Date();
};

const addMonths = (baseDate, monthsToAdd) => {
  const d = new Date(baseDate instanceof Date ? baseDate.getTime() : Date.now());
  const m = Number.parseInt(String(monthsToAdd), 10) || 0;
  d.setMonth(d.getMonth() + m);
  return d;
};
